export enum CommunicationBannerMoment {
  HOME = 'HOME',
  CHECKOUT = 'CHECKOUT',
}

export enum CommunicationBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SALE = 'SALE',
}

export type CommunicationBanner = {
  id: string;
  title: string;
  copy: string;
  type: CommunicationBannerType;
  moment: CommunicationBannerMoment;
  startsAt: string;
  endsAt: string;
  dismissable: boolean;
  ctaLabel: string | null;
  ctaUrl: string | null;
};

export type CommunicationBannerResponse = {
  banner: CommunicationBanner | null;
};
